export var FlightRules;
(function (FlightRules) {
    FlightRules["I"] = "I";
    FlightRules["V"] = "V";
    FlightRules["Y"] = "Y";
    FlightRules["Z"] = "Z";
})(FlightRules || (FlightRules = {}));
export const flightRulesLabels = new Map([
    [FlightRules.I, 'IFR'],
    [FlightRules.V, 'VFR'],
    [FlightRules.Y, 'IFR-VFR'],
    [FlightRules.Z, 'VFR-IFR'],
]);
export const flightRuleOptions = generateLabels(flightRulesLabels);
export var TypeOfFlight;
(function (TypeOfFlight) {
    TypeOfFlight["G"] = "G";
    TypeOfFlight["N"] = "N";
    TypeOfFlight["X"] = "X";
    TypeOfFlight["S"] = "S";
    TypeOfFlight["M"] = "M";
})(TypeOfFlight || (TypeOfFlight = {}));
export const typeOfFlightLabels = new Map([
    [TypeOfFlight.N, 'Commercial'],
    [TypeOfFlight.G, 'General'],
    [TypeOfFlight.X, 'Training/Other'],
    [TypeOfFlight.S, 'State'],
    [TypeOfFlight.M, 'Mil'],
]);
export const typeOfFlightOptions = generateLabels(typeOfFlightLabels);
export const typeOfFlightOptionsUsual = typeOfFlightOptions.slice(0, 3);
export const typeOfFlightOptionsUsualShort = [
    { value: TypeOfFlight.N, label: 'CAT' },
    { value: TypeOfFlight.G, label: 'NC' },
    { value: TypeOfFlight.X, label: 'ATO' },
];
function generateLabels(labelMap) {
    return [...labelMap.entries()].map(([value, label]) => ({ value, label }));
}
//# sourceMappingURL=FlightPlanTypes.js.map